import { AODA } from "@core/utilities/aoda";
import {
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewEncapsulation,
} from "@angular/core";
import { BaseComponent } from "@shared/components/base.component";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-result-type-filter",
  templateUrl: "./result-type-filter.component.html",
  styleUrls: ["./result-type-filter.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ResultTypeFilter extends BaseComponent implements OnInit, OnDestroy {
  
  @Input() f: FormGroup;
  @Output() enableFilter = new EventEmitter<boolean>(false);
  displayResultTypeFilter: boolean = false;

  constructor(
    private injector: Injector,
    private el: ElementRef,
    private r2: Renderer2,
  ) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
  }

  //Filter Functions
  onDisplayResultTypeFilter() {
    this.displayResultTypeFilter = !this.displayResultTypeFilter;
  }

  onResultTypeChange(event: any) {
    var resultTypeId = event.value;
    for (var i = 0; i < this.resultTypes.value.length; i++) {
      var result = this.resultTypes.value[i];
      result.checked = resultTypeId === result.id ? true : false;
    }

    if(resultTypeId == 1) {
      this.enableFilter.emit(false);
    } else {
      this.enableFilter.emit(true);
    }
    
    this.resultTypes.setValue(this.resultTypes.value);
  }

  get resultTypes() {
    return this.f.get("resultTypes");
  }

}
